const e=e=>{e.state.query&&e.search()};export{e as searchFunctionWithoutInitialLoad};
